
  function setupColorPickers(sectionId) {
    // 字体颜色相关元素
    const fontColorPicker = document.getElementById(`${sectionId}FontColorPicker`);
    const fontColorPreview = document.getElementById(`${sectionId}FontColorPreview`);
    const fontColorInput = document.getElementById(`${sectionId}FontColorInput`);

    // 外框颜色相关元素
    const outlineColorPicker = document.getElementById(`${sectionId}OutlineColorPicker`);
    const outlineColorPreview = document.getElementById(`${sectionId}OutlineColorPreview`);
    const outlineColorInput = document.getElementById(`${sectionId}OutlineColorInput`);

    // 初始化颜色预览框和输入框的颜色
    fontColorPreview.style.backgroundColor = fontColorInput.value;
    fontColorPicker.value = fontColorInput.value;

    outlineColorPreview.style.backgroundColor = outlineColorInput.value;
    outlineColorPicker.value = outlineColorInput.value;

    // 处理字体颜色选择器
    fontColorPicker.addEventListener('input', function () {
      const selectedColor = fontColorPicker.value;
      fontColorPreview.style.backgroundColor = selectedColor;
      fontColorInput.value = selectedColor;  // 更新输入框的 Hex 值
    });

    // 处理外框颜色选择器
    outlineColorPicker.addEventListener('input', function () {
      const selectedColor = outlineColorPicker.value;
      outlineColorPreview.style.backgroundColor = selectedColor;
      outlineColorInput.value = selectedColor;  // 更新输入框的 Hex 值
    });

fontColorInput.addEventListener('input', function () {
  const inputColor = fontColorInput.value.trim(); // 去除前后空格

  // 检查输入值是否为有效的 Hex 颜色格式
  const validHex = /^#[0-9A-Fa-f]{6}$|^#[0-9A-Fa-f]{3}$/.test(inputColor);

  if (validHex) {
    fontColorPreview.style.backgroundColor = inputColor;
    fontColorPicker.value = inputColor; // 更新 color picker 的颜色
    fontColorInput.style.borderColor = ''; // 恢复输入框边框颜色
  } else {
    fontColorInput.style.borderColor = 'red'; // 无效 Hex 格式时改变边框颜色
  }
});

outlineColorInput.addEventListener('input', function () {
  const inputColor = outlineColorInput.value.trim(); // 去除前后空格

  // 检查输入值是否为有效的 Hex 颜色格式
  const validHex = /^#[0-9A-Fa-f]{6}$|^#[0-9A-Fa-f]{3}$/.test(inputColor);

  if (validHex) {
    outlineColorPreview.style.backgroundColor = inputColor;
    outlineColorPicker.value = inputColor; // 更新 color picker 的颜色
    outlineColorInput.style.borderColor = ''; // 恢复输入框边框颜色
  } else {
    outlineColorInput.style.borderColor = 'red'; // 无效 Hex 格式时改变边框颜色
  }
});


    // 点击字体颜色预览框时触发 color picker
    fontColorPreview.addEventListener('click', function () {
      fontColorPicker.click();
    });

    // 点击外框颜色预览框时触发 color picker
    outlineColorPreview.addEventListener('click', function () {
      outlineColorPicker.click();
    });
  }

  function setupToggleButton(buttonId, sectionId) {
    const toggleButton = document.getElementById(buttonId);
    const colorOptions = document.getElementById(sectionId);

    toggleButton.addEventListener('click', () => {
      colorOptions.classList.toggle('open');
    });
  }

  // 初始化颜色选择器
  setupColorPickers('teamName');
  setupColorPickers('name');
  setupColorPickers('number');

  // 初始化颜色选项切换按钮
  setupToggleButton('toggleTeamNameColorOptions', 'teamNameColorOptions');
  setupToggleButton('toggleNameColorOptions', 'nameColorOptions');
  setupToggleButton('toggleNumberColorOptions', 'numberColorOptions');
